<ion-row class="phi-align-items-center">
  <ion-col size>
    <h5 class="ml-10 fw-b">Task Reassignment</h5>
  </ion-col>
  <ion-col size="auto">
    <button matButton mat-dialog-close class="dialog_btns close_btn"><ion-icon name="close-outline"></ion-icon></button>
  </ion-col>
</ion-row>

<mat-dialog-content>
  <div class="approve-data mb-15">
    <p class="mb-15">
      <span class="fw-bold">Reassign Task From:</span>
      {{matDialogData.userName}}
    </p>
    <div class="mb-15">
      <div class="select-emp phi-flex-wrap-center phi-gap-8">
        <span class="fw-bold " *ngIf="!matDialogData?.exitedMode || filteredDwmManagerUser?.length">To:</span>
        <ng-select class="w-100 mw-sm-250 mat-height40 mat-input-style" *ngIf="filteredDwmManagerUser?.length" [searchable]="true" [clearable]="false" placeholder="Select Employee" [(ngModel)]="selectedEmpId" dropdownPosition="bottom" (change)="checkIfEmpHasSkipDay()">
          <ng-option [value]="item.id" *ngFor="let item of filteredDwmManagerUser">{{ item.firstName }} {{ item.lastName }}</ng-option>
        </ng-select>
        <span class="fs-14" *ngIf="matDialogData?.exitedMode && !filteredDwmManagerUser?.length">No employee under this manager to reassign tasks to.</span>
      </div>
    </div>
    <div>
      <button class="add_btn" *ngIf="!matDialogData?.exitedMode || filteredDwmManagerUser?.length" (click)="reassignTasks()">Reassign Tasks</button>
    </div>
  </div>
</mat-dialog-content>
